/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Card_BodyInputs */

const en_us2_quick_workout_card_body = /** @type {(inputs: Quick_Workout_Card_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short on time? Say how many minutes you have and the app builds a session for now, from what has recovered.`)
};

const pt_br2_quick_workout_card_body = /** @type {(inputs: Quick_Workout_Card_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouco tempo hoje? Diga quantos minutos você tem e o app monta um treino para agora, com o que está recuperado.`)
};

const es_419_quick_workout_card_body = /** @type {(inputs: Quick_Workout_Card_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Poco tiempo hoy? Di cuántos minutos tienes y la app arma un entrenamiento para ahora, con lo que ya se recuperó.`)
};

const pt_pt2_quick_workout_card_body = /** @type {(inputs: Quick_Workout_Card_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouco tempo hoje? Diz quantos minutos tens e a app monta um treino para agora, com o que está recuperado.`)
};

const fr_fr2_quick_workout_card_body = /** @type {(inputs: Quick_Workout_Card_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peu de temps ? Dis combien de minutes tu as et l'appli te prépare une séance pour maintenant, avec ce qui a récupéré.`)
};

const de_de2_quick_workout_card_body = /** @type {(inputs: Quick_Workout_Card_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenig Zeit? Sag, wie viele Minuten du hast, und die App stellt dir jetzt ein Training aus dem zusammen, was erholt ist.`)
};

const it_it2_quick_workout_card_body = /** @type {(inputs: Quick_Workout_Card_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poco tempo oggi? Dimmi quanti minuti hai e l'app crea una sessione per adesso, con ciò che si è già recuperato.`)
};

/**
* | output |
* | --- |
* | "Short on time? Say how many minutes you have and the app builds a session for now, from what has recovered." |
*
* @param {Quick_Workout_Card_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_card_body = /** @type {((inputs?: Quick_Workout_Card_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Card_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_card_body(inputs)
	if (locale === "es-419") return es_419_quick_workout_card_body(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_card_body(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_card_body(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_card_body(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_card_body(inputs)
	return en_us2_quick_workout_card_body(inputs)
});
export { quick_workout_card_body as "quick-workout.card_body" }